/* eslint-disable react/prop-types */
import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../app/pages/Login";
import ShowNotice from "../app/pages/ShowNotice";
import SignUp from "../app/modules/SignUp";
import ForgotPassword from "../app/modules/Login/ForgotPassword";
import ChangePassword from "../app/modules/Login/ChangePassword";
import Success from "../app/modules/Login/Success";
import PropertyList from "../app/modules/Properties/PropertyList";
import CreateProperty from "../app/modules/Properties/AddProperty/CreateProperty";
import OfferByTenant from "../app/modules/Properties/OfferByTenant";
import Leads from "../app/modules/LeadManagement/Leads/Leads";
import LeadsDetail from "../app/modules/LeadManagement/LeadsDetail/leadsDetail";
import PropertyDetail from "../app/modules/Properties/PropertyDetail";
import Reviews from "../app/modules/Reviews";
import PropertyReview from "../app/modules/Reviews/PropertyReview";
import Tenants from "../app/modules/Tenants";
import Units from "../app/modules/Units";
import Notices from "../app/modules/Notices";
import AddTenant from "../app/modules/Tenants/AddTenant";
import Maintenance from "../app/modules/Maintenance";
import VisitScheduling from "../app/modules/Properties/VisitScheduling";
import PropertiesOnMap from "../app/modules/Properties/PropertiesOnMap";
import OpportuntiyList from "../app/modules/LeadManagement/OpportunityList";
import OpportunityDetail from "../app/modules/LeadManagement/OpportunityDetail";
import ContractBookingForm from "../app/modules/ContractFlow/ContractBookingForm";
import TenantDetails from "../app/modules/Tenants/TenantDetails";
import UnitDetail from "../app/modules/Properties/PropertyDetail/UnitDetail";
import EjariList from "../app/modules/Ejari";
import BookingformList from "../app/modules/BookingformList";
import ContractsList from "../app/modules/Contracts";
import MoveOut from "../app/modules/MoveOut";
import Notification from "../app/modules/Notification";
import SignUpNew from "../app/modules/SignUpNew";
import OTP from "../app/modules/SignUpNew/OTP";
import CreatePassword from "../app/modules/SignUpNew/CreatePassword";
import PostDatedCheques from "../app/modules/Contracts/PostDatedCheques";
import Receipts from "../app/modules/Contracts/Receipts";
import ContractDetail from "../app/modules/Contracts/ContractDetail";
import AllProspects from "../app/modules/Tenants/AllProspects";
import ContractTenantDetails from "../app/modules/ContractTenantDetails";
import NotificationCalendar from "../app/modules/Notification/NotificationCalendar";
import ChequesApproval from "../app/modules/ChequesApproval";
import Managers from "../app/modules/Managers";
import ServiceProvider from "../app/modules/ServiceProvider";
import Tickets from "../app/modules/Maintenance/Tickets/Tickets";
import Technicians from "../app/modules/Maintenance/Technicians/Technicians";
import Roster from "../app/modules/Maintenance/Roster/Roster";
import Zones from "../app/modules/Maintenance/Zones/Zones";
import Configurations from "../app/modules/Configurations";
import Shifts from "../app/modules/Configurations/Shifts/Shifts";
import Categories from "../app/modules/Configurations/Categories/Categories";
import PublicHolidays from "../app/modules/Configurations/PublicHolidays/PublicHolidays";
import BookingListing from "../app/modules/BookingListing";
import BookingRenewalListing from "../app/modules/BookingRenewalListing";
import BookingDashboard from "../app/pages/BookingDashboard";
import MaintenanceDashboard from "../app/pages/Maintenance";
import ServiceRequests from "../app/pages/Maintenance/ServiceRequests";
import RenewalDashboard from "../app/pages/RenewalDashboard";
import RenewalForm from "../app/modules/LeasingFormNew/RenewalForm";
import BookingForm from "../app/modules/LeasingFormNew/BookingForm";
import NotFound from "../app/modules/NotFound";
import ContactUs from "../app/modules/Contact Us";
import Unauthorized from "../app/modules/Unauthorize";
import NewBookingForm from "../app/modules/BookingForm/BookingForm";
import ViewBookingForm from "../app/modules/BookingForm/ViewBookingForm";
import TerminationProcess from "../app/modules/TerminationProcess/TerminationProcess";
import PaymentProcess from "../app/modules/PaymentProcess";
import { dashboardAccessManager } from "../utils/dashBoardAccess";
import Owner from "../app/modules/Owner";
import { SSOCallback, SSO_CALLBACK_PATH } from "../app/modules/Login/SSOCallback";
import { isLoggedIn } from "../utils/session";
import { usePagesSetup } from "./shared/usePagesSetup";
import AuthenticatedLayout from "./AuthenticatedLayout";

const LegacyPages = (props) => {
  const { withScreenAccess, shouldRenderReceiptsRoute, navigate } = usePagesSetup(props);

  const CustomDashboard = () => {
    if (dashboardAccessManager("bookings")) {
      return <BookingDashboard />;
    }
    if (dashboardAccessManager("renewals")) {
      navigate("/renewal/dashboard");
      return null;
    }
    if (dashboardAccessManager("maintenance")) {
      navigate("/maintenance/dashboard");
      return null;
    }
    return <BookingDashboard />;
  };

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path={SSO_CALLBACK_PATH} element={<SSOCallback />} />
      <Route path="/notice" element={<ShowNotice />} />
      <Route path="/register" element={<SignUp />} />
      <Route path="/signup" element={<SignUpNew />} />
      <Route path="/otp" element={<OTP />} />
      <Route path="/create-password" element={<CreatePassword />} />
      <Route path="/succcreateess" element={<Success />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="payments/process/:leaseId/:userId" element={<PaymentProcess />} />
      {isLoggedIn() ? (
        <>
          <Route path="/offer-by-tenant/:id" element={<OfferByTenant />} />
          <Route path="/maintenance/:id" element={<Maintenance />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/create-a-property" element={<CreateProperty />} />

          <Route element={<AuthenticatedLayout />}>
            <Route path="/booking-form/:id" element={<BookingForm />} />
            <Route path="/dashboard" element={<CustomDashboard />} />

            <Route
              path="/maintenance/dashboard"
              element={withScreenAccess(MaintenanceDashboard, "maintenance", true)}
            />

            <Route path="renewal/dashboard" element={withScreenAccess(RenewalDashboard, "renewals", true)} />
            <Route path="/properties" element={withScreenAccess(PropertyList, "properties")} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/tenants/:id" element={<Tenants />} />
            <Route path="/managers/:id" element={<Managers />} />
            <Route path="/add-tenant" element={<AddTenant />} />
            <Route path="/property-review" element={<PropertyReview />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/lead-detail/:id" element={<LeadsDetail />} />
            <Route path="/property-detail/:id" element={<PropertyDetail />} />
            <Route path="/property-detail/:id/unit/:id" element={<UnitDetail />} />
            <Route path="/visit-scheduling/:id" element={<VisitScheduling />} />
            <Route path="/visit-scheduling" element={<VisitScheduling />} />
            <Route path="/properties-map" element={<PropertiesOnMap />} />
            <Route path="/opportunities" element={<OpportuntiyList />} />
            <Route path="/opportunity-detail/:id/:assetId/:partyId" element={<OpportunityDetail />} />
            <Route path="/detail-tenant/:id/:partyId" element={<ContractTenantDetails />} />

            <Route path="/tenants" element={withScreenAccess(Tenants, "tenants")} />
            <Route path="/users" element={withScreenAccess(Managers, "users")} />
            <Route path="/owners" element={<Owner />} />
            <Route path="/cheques/:id" element={<ChequesApproval />} />
            <Route path="/tenants-detail/:id" element={<TenantDetails />} />
            <Route path="/bookingforms" element={withScreenAccess(BookingformList, "leases")} />
            <Route path="/bookings/form" element={<BookingForm />} />
            <Route path="/newbookingform" element={<NewBookingForm />} />
            <Route path="/newbookingform/:leaseId" element={<NewBookingForm />} />
            <Route path="/viewbookingform/:leaseId/*" element={<ViewBookingForm />} />
            <Route path="/bookings/form/:LEASEID" element={<BookingForm />} />
            <Route path="/renewals/form/:LEASEID" element={<RenewalForm />} />

            <Route path="/leads/:leadId/booking-form/:assetId/:partyId" element={<ContractBookingForm />} />
            <Route path="/ejari" element={<EjariList />} />
            <Route path="/bookings" element={withScreenAccess(BookingListing, "bookings")} />
            <Route path="/booking-Renewals" element={withScreenAccess(BookingRenewalListing, "renewalsInProgress")} />
            <Route path="/contracts" element={withScreenAccess(ContractsList, "upcomingRenewals")} />
            <Route path="/move-outs" element={withScreenAccess(MoveOut, "moveouts")} />

            <Route path="/contract-detail/:id" element={<ContractDetail />} />
            <Route path="/invoicing" element={withScreenAccess(PostDatedCheques, "payments")} />
            {shouldRenderReceiptsRoute && <Route path="/receipts" element={<Receipts />} />}
            <Route path="/prospects" element={<AllProspects />} />
            <Route path="/prospect-detail/:id" element={<TenantDetails />} />
            <Route path="/notifications" element={<Notification />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/notifications/calendar" element={<NotificationCalendar />} />

            <Route path="/service-providers" element={withScreenAccess(ServiceProvider, "serviceProviders")} />
            <Route path="/tickets" element={withScreenAccess(Tickets, "tickets")} />
            <Route path="/technicians" element={<Technicians />} />
            <Route path="/roster" element={<Roster />} />
            <Route path="/zones" element={<Zones />} />
            <Route path="/service-requests" element={<ServiceRequests />} />

            <Route path="/configurations" element={<Configurations />} />
            <Route path="/open-hours" element={<Shifts />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/notices" element={withScreenAccess(Notices, "notices")} />
            <Route path="/public-holidays" element={<PublicHolidays />} />

            <Route path="/units" element={<Units />} />
            <Route path="/move-out/summery/:leaseId" element={<TerminationProcess />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
};

export default LegacyPages;
